import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { ChatPage } from "./pages/ChatPage";
import { InteractiveChatPage } from "./pages/InteractiveChatPage";
import { HomePage } from "./pages/HomePage-simple";
import { RequirementsPage } from "./pages/RequirementsPage";
import "./App.css";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<InteractiveChatPage />} />
          <Route path="/chat" element={<ChatPage />} />
          <Route path="/old" element={<HomePage />} />
          <Route path="/requirements" element={<RequirementsPage />} />
          <Route
            path="*"
            element={
              <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="text-center">
                  <h1 className="text-4xl font-bold text-gray-900 mb-4">404</h1>
                  <p className="text-gray-600 mb-8">Page not found</p>
                  <a
                    href="/"
                    className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
                  >
                    Go Home
                  </a>
                </div>
              </div>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
